import axiosInstance from "../axiosInstance";

export const GETStockUbicacionArticulo = async (idubid, idartl) => {
  try {
    const response = await axiosInstance.get(
      `${process.env.REACT_APP_WMS_BASE_URL}/ordenes/stock-ubicacion-articulo`,
      {
        params: {
          idubid,
          idartl,
        },
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default GETStockUbicacionArticulo;
